import { _p, _e, encrypt } from './core.crypto';

interface SecureConfig {
  API_REST_URL_AUTH_SECURE: string;
  API_REST_URL_AUTH_PUBLIC: string;
  API_REST_URL_PROXY: string;
  API_REST_URL: string;
  CONFIG_WORD: string;
  REACT_APP_LMS_URL: string;
  REACT_APP_COMMUNITY_URL: string;
}

// Configuraciones encriptadas por entorno (índices: 0=prod, 1=stg, 2=walmart, 3=walmart_lapzo, 4=dev)
const _c = [
  // Production [0]
  {
    API_REST_URL_AUTH_SECURE: 'U2FsdGVkX1+Vff17jiAGBrQ5x3OD4we+8hM2Ap5NwZyE6WZ1rZpr/W8kqNlSSIWvkLbY9Y9QOiiEcuZk9vMIWjdjc5zCjA+GcUdWMCcA/Vs=',
    API_REST_URL_AUTH_PUBLIC: 'U2FsdGVkX1/uV4vUWEGrycSJumnvU6uPI34YMq9z4p1LZXo1QVxoxVz80BG1mT1mdOZsPPIAqBaO9+dxC4P/maLAcTMs+av5bxoYBckHNtE=',
    API_REST_URL_PROXY: 'U2FsdGVkX1/HRVlmcGP8cxHAp9Ug4vWrtIsrlD+7w9GLZ1Q4vSwUpEWvfBFs4soIjp+ygV6h4htIVIlCg6w5Rw==',
    API_REST_URL: 'U2FsdGVkX1+ieHq+VGi5joKuPXgXqHh9ZLZvraZUcPgHIDKsnQk7dLe6rFGUoUKWC4lj/wGCfzj+C4qXUKJ3ug==',
    CONFIG_WORD: 'U2FsdGVkX19jvmZLHXeZwa5mzMWoF4/1h3EmAAtUh2yCzGwMBSP69cy7aY2ViZX0us7h1sjCCJiMAu5QC0EMVg==',
    REACT_APP_LMS_URL: 'U2FsdGVkX18qZRNH0tGC/QLzClycNl6qEKn69FmICo1+iKA6DU/JgKTvAAh07lfG',
    REACT_APP_COMMUNITY_URL: 'U2FsdGVkX19P6kdAsB2+0rDq3+5v2/DuMN98JRGzwiGYwJ/I4iKvQQZkMpxdw/Bq'
  },
  // Staging [1]
  {
    API_REST_URL_AUTH_SECURE: 'U2FsdGVkX1/Rc3ocD89wX1LfasbfArWk/X92rCWAJsRLyQmvYECt++KaWj0sIEn7Gsm8sMkkKZJRSUzkRQoM7DggFmWCqDjplRI+TPE3Dqc=',
    API_REST_URL_AUTH_PUBLIC: 'U2FsdGVkX192Bx/q+p1SkPqSirS5Qqlhnp7GY95SHhRJH5WzvMn0soPSimFiy+8u3veQpG7QCouCfhVtfyZXV0hYpOZUBt0kv8BHzsxyF+w=',
    API_REST_URL_PROXY: 'U2FsdGVkX1/B67Ss36qMyLJG2JWE700WktB9brtJZWaY6V/6u6CQhdrxovICv4bu1Bp6oD3Uw1l/bUU/ZPZsqw==',
    API_REST_URL: 'U2FsdGVkX1+HS7sHm42x1TTjVgaLTuLD++WN6sdzBDtMOV5VWzJ0+VbCSOBu3EXhis9zmgSvDqXKQ5vbV6j0Ww==',
    //API_REST_URL: encrypt('https://temp-deploy-dot-lernit-platform-stg-dot-lapzo-platform-stg.uc.r.appspot.com'),
    CONFIG_WORD: 'U2FsdGVkX1/r00pNGx67mFU46QjxI/9aiG9goULVeMQDz3/dh1JHVSa4G4r8H+M+hko55bBG/yKOIjGgPj8naQ==',
    REACT_APP_LMS_URL: 'U2FsdGVkX1+ygMVmMtJmc8J8pIceG8FPz2TRKBA1UITdEHSCYPpv7iCB0HtoUthn',
    REACT_APP_COMMUNITY_URL: 'U2FsdGVkX1/uC5XMeAbKWBP/mdwDRcEAngDxK9wplpVd58dZcU4yJwsbd2zE70/G'
  },
  // Walmart [2]
  {
    API_REST_URL_AUTH_SECURE: 'U2FsdGVkX1989AiSyZ6rmDIjsih4Sh7vjj0a/NgKniMd3WLrO3aFjB48+7NhykjCbbi4qTEkcIzA1RFVEOVTg7VsueP6BvBTPd36uAiBQ0bWfwf/S81f+guzAiOoP+UZ8fQy/6gKTLE71mTmUQ2KZQ==',
    API_REST_URL_AUTH_PUBLIC: 'U2FsdGVkX1+mZI30jrNXYmGYGPynWx4+oElpq7Pyve+kppEs9eZMzZ2SreDCQbxZwEdA23ET3RSvTt4liwOFeDLO2jJmTa8bSQAi01fCsG3DM9ZDb1L7o8QJnpIBkNDW',
    API_REST_URL_PROXY: 'U2FsdGVkX1/YTcT0DqezgLjZrjBb4cql7dJdTLCEGTauc+6EQPRRN4XQFpytophdpP/4hSG/Y8Nzn2i3iZjlFDcGJoYF/gFHT83VKYYKZQhX3JlNqy7AVlv0JaeNGMdg',
    API_REST_URL: 'U2FsdGVkX18uclyTA22eZKTzt1QFavWGoYBmXBvV9HCcSzia2eAHkm7wdyS++qt9FKTkgGxuGwbYnEq1gyos8uB6KiSF0/zg7WJlYNbu+0ALqdChz8/9rndBwZ1RBrkd',
    CONFIG_WORD: 'U2FsdGVkX19c5Fc9bG4xTSuatN9XBK/uV9RXsd+0fPJKQTGAt1ZndcBSgrwR3SqPatGlHzJy/+rqV0U0w9kwng==',
    REACT_APP_LMS_URL: 'U2FsdGVkX1/nphMRcWGQd6jDxafXS3/JrFcglLq6vBAkG311aLW3HFE8Qc1z51Vc216m7UbJPswAmOkZeoxIVw==',
    REACT_APP_COMMUNITY_URL: 'U2FsdGVkX1/OWcf6vMX5wNoJuTVfHExd0Z1vokaU1pu91XhkFB4RXkvqtkzhS9Xy'
  },
  // Walmart Lapzo [3]
  {
    API_REST_URL_AUTH_SECURE: 'U2FsdGVkX18ZHZfEzBoBw6dc8/r+4csTFN4YICLC+EDrJtgbVnvdpfaK1aQtkI9c4Pu/ShpYB5cvc0W8rIbChJYpXK6/YqoFFGT2njWgsxihQllwSoks4pmj7U+qvRTa',
    API_REST_URL_AUTH_PUBLIC: 'U2FsdGVkX1/UypOO2AM8ddWDEH7FAcUeI9HTECg38QKizCzKvDxj/EfD116hJwrmpKcrk1RaqzWUGWEbmqDtfCthNWQeIioQmVAnB4ouoCR/wkmQPCLgkd4jK+snPMLb',
    API_REST_URL_PROXY: 'U2FsdGVkX1+iC1g3G2CE23gaGf/HY/35tPW9VubK5CycD5tUrtr8LvMoWvdiE/uIe/62OgPCxpkMRPU9NjP1Prax6U/NOwKCxtsSV9UKkplTJ7InAgUKtpIXnkl6rZzz',
    API_REST_URL: 'U2FsdGVkX1+Gx3WJ1Agln31PJtug5LB98q7towiEM7sREmlKGTkYaOI4pNUKmbxN5nAgHr7/ucgmg/6lXYI67ASm+JGZl8RhebItPvWqqQM=',
    CONFIG_WORD: 'U2FsdGVkX19D53S8DI6TzDoQkWLhrOtKZptPK2Mq+JCYGR7ZdUf2znMVWWX/2q/qYcpvKmBogqSolEz9mH5Pew==',
    REACT_APP_LMS_URL: 'U2FsdGVkX198S5u5BmLkI93d/W5g1yRgzGcsUhL2iRE+n2Mb8hVKastS8tWqweRb',
    REACT_APP_COMMUNITY_URL: 'U2FsdGVkX1/OWcf6vMX5wNoJuTVfHExd0Z1vokaU1pu91XhkFB4RXkvqtkzhS9Xy'
  },
  // Development [4]
  {
    API_REST_URL_AUTH_SECURE: 'U2FsdGVkX1+NrCxCInlzy61LhEwiBozdU1hg2YsMt6u6Rkf0APk2l/Lky6Y5oAnPuXEUBSAGyHhKTl8FAY/ca4wJbhCAvci6WU9CwMjzrUU=',
    API_REST_URL_AUTH_PUBLIC: 'U2FsdGVkX19XQLiNgXb8MKs9eZPzwd8k2Bc50DdIgmX/QjYNhatdFXC5SpXPcVncHNs3a0kCMmsuSn/kab7KHs6XY9ICP+Z5rGN9hSKEnss=',
    API_REST_URL_PROXY: 'U2FsdGVkX1/fQ64/W1rybmAA12Nwi4Q/fyBgvkwxnmkjjGG+cACQgYnjj/QUSRpDk5e4Z+9UxYjX+LdKso4rkg==',
    API_REST_URL: 'U2FsdGVkX19GILa+EBcpHlwWU1GOt5jSXqJjaabJFtgz6w//GV2s4G2f9MQiKthDRq9qyAbYb8HTqcbXjZujfQ==',
    CONFIG_WORD: 'U2FsdGVkX1+AVmUztNJ37Ko4hUR4QNuIxMBLjsQiLkzx16ewI1qJC7YddQ3hZ3F9fwxk3Wln594pBLBt/fvksQ==',
    REACT_APP_LMS_URL: 'U2FsdGVkX1+hypIU1KLv33MO0+dKD/X9+VVJxJ8JoshtKSwRwo+1piuCq87F07s8',
    REACT_APP_COMMUNITY_URL: 'U2FsdGVkX19Tr1JDVpSGS/bHBu978nAwBEDFXL6z0cV8teSB7Fi9vaN8E+SLRbw6'
  }
];

const _g = (): SecureConfig => {
  const idx = parseInt(_e(), 10);
  const cfg = _c[idx] || _c[0]; // Fallback a producción
  return _p<SecureConfig>(cfg);
};

export const SECURE_CONFIG = _g();